module.exports = __webpack_public_path__ + "static/media/13_negro.b1ca500a.svg";